import type { Project } from '../../data/projects';
import styles from './ProjectScreen.module.css';

type ImageLoading = 'eager' | 'lazy';

interface ProjectScreenProps {
    project: Project;
    alt: string;
    loading?: ImageLoading;
    className?: string;
}

const SCREEN_WIDTH = 600;
const SCREEN_HEIGHT = 1200;

export default function ProjectScreen({ project, alt, loading = 'lazy', className }: ProjectScreenProps) {
    return (
        <img
            className={[styles.frame, className].filter(Boolean).join(' ')}
            src={project.screenSrc}
            alt={alt}
            width={SCREEN_WIDTH}
            height={SCREEN_HEIGHT}
            loading={loading}
            decoding="async"
        />
    );
}
